import { Swiper } from "swiper";
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';

if(document.getElementById("gdiSwiper")) {
  const swiper = new Swiper('#gdiSwiper', {
    modules: [ Pagination, EffectFade, Navigation, Autoplay],
    direction: 'horizontal',
    loop: true,
    effect: "swipe",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: '.facts-swiper-button-next',
      prevEl: '.facts-swiper-button-prev',
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    speed: 1200,
    slidesPerView: 1,
  });
  swiper.autoplay.start();
}

  if(document.getElementById("homeSwiper")) {
      var homeSwiper = new Swiper('.home-swiper', {
        modules: [ Pagination, Navigation ],
      loop: false,
spaceBetween: 20,
effect: 'slide',
speed: 800,
breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
    },
// Allows slides to have their own width (defined by CSS)
centeredSlides: true,  // Centers the active slide
pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: "fraction",
},
navigation: {
    nextEl: '.home-swiper-button-next',
    prevEl: '.home-swiper-button-prev',
},

        
        onTransitionStart: function(swiper) {
            jQuery('#slider-content-area').removeClass('active').addClass('slider-content-fade');
        },
        onTransitionEnd: function(swiper) {
            jQuery('#slider-content-area').removeClass('slider-content-fade').addClass('active');
        },
    });

    const $sliderContentArea = jQuery('#slider-content-area');
    const $sliderTitle = jQuery('#slider-title');
    const $sliderButton = jQuery('#slider-button');

    function updateSliderContent(index) {
        const slideData = allSlidesData[index];

        if (slideData) {
            $sliderTitle.text(slideData.title);
            $sliderButton.attr('href', slideData.link);
        }
    }

    updateSliderContent(homeSwiper.realIndex); 
    $sliderContentArea.addClass('active'); 
    homeSwiper.on('slideChangeTransitionStart', function() {
      
      $sliderContentArea.removeClass('active');
    });

    homeSwiper.on('slideChangeTransitionEnd', function() {
        // Update content after the slide transition is complete
       updateSliderContent(homeSwiper.realIndex);

        // Fade in the new content
        $sliderContentArea.addClass('active');
    });
    
    }
